export const ERRORS = {
  BAD_REQUEST: "Bad Request",
  INVALID_MOBILE_NUMBER: "Invalid mobile number",
  SOMETHING_WENT_WRONG: "Something went wrong!",
  PLEASE_CONTACT_ADMIN: "Please contact admin",
};
